






























































































import { Component, Vue, Watch } from "vue-property-decorator";
import { trainList, trainMedal, trainAllList } from "@/api/task/train";
import { PAGINATION_PARAM } from "@/global/constants";
import moment from "moment";

@Component
export default class TrainNew extends Vue {
  private trainList: object = [];
  private medalList: object = [];
  private params: object = {
    rows: 20,
    ...PAGINATION_PARAM,
  };
  private type = 1;
  private total = 0;

  private created() {
    this.getList(this.params);
    this.getMedal();
  }

  private async getList(params) {
    params.rows = (this.params as any).pagesize;
    try {
      const data: any = await trainAllList(params);
      this.$nextTick(() => {
        // this.trainList = data ? data.rows : [];
        const arr: object[] = data || [];
        const obj = {};
        arr.forEach((item: any) => {
          if (Array.isArray(obj[item.type])) {
            obj[item.type].push(item);
          } else {
            obj[item.type] = [item];
          }
        });
        this.trainList = obj;
        // this.total = data ? data.total : 0;
      });
      console.log(this.trainList);
    } catch (error) {
      console.log(error);
    }
  }

  private async getMedal() {
    try {
      const data: any = await trainMedal();
      this.$nextTick(() => {
        // this.medalList = data
        const arr: object[] = data || [];
        const obj = {};
        arr.forEach((item: any) => {
          if (Array.isArray(obj[item.type])) {
            obj[item.type].push(item);
          } else {
            obj[item.type] = [item];
          }
        });
        this.medalList = obj;
      });
    } catch (error) {
      console.log(error);
    }
  }

  private goDetail(id, title) {
    window.open("/trainDetail?id=" + id + "&title=" + title, "_blank");
  }

  formatter_10_ymd(v) {
    if (!v) return null;
    return moment.unix(v).format("YYYY-MM-DD");
  }
  private types = {
    1: {
      color: "#FFF4D4",
      name: "新兵营",
      trainIcon: "train-newcomer-icon",
      medalIcon: "medal-newcomer-icon",
    },
    2: {
      color: "#FFEEE2",
      name: "工具培训",
      trainIcon: "train-tool-icon",
      medalIcon: "medal-tool-icon",
    },
    3: {
      color: "#FFE6E6",
      name: "项目培训",
      trainIcon: "train-project-icon",
      medalIcon: "medal-project-icon",
    },
    4: {
      color: "#FFE6EF",
      name: "内部培训",
      trainIcon: "train-company-icon",
      medalIcon: "medal-company-icon",
    },
    5: {
      color: "#F5E6FF",
      name: "基地培训",
      trainIcon: "train-jidi-icon",
      medalIcon: "medal-jidi-icon",
    },
  };
  private getTypeData(type) {
    return this.types[type] || {};
  }
  private background(type) {
    const color = this.getTypeData(type).color;
    return `background-image: linear-gradient(45deg, ${color} 0%, #ffffff 20%, #ffffff 80%, ${color} 100%);`;
  }
  private changePage() {}
}
